<template>
	<div class="table" v-if="purchaseList.length > 0">
		<div v-for="item in purchaseList" :key="item.seq" class="table_item">
			<div class="list_item">
				<div class="list_num">{{ item._no }}</div>
				<div class="item_box">
					<div class="item">
						<p>{{ $t('rtr_activity-c2c.purchased_asset') }}</p>
						<div class="asset_box mb_10">
							<span :class="[item.source_asset_code, 'small']"></span>
							<p class="code mr_4">{{ item.source_asset_code }}</p>
							<p class="name">{{ item.source_asset_title }}</p>
						</div>
						<p class="fs_12 fc_gray2">
							{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
						</p>
					</div>
					<div class="item">
						<p>{{ $t('rtr_activity-c2c.purchase_quantity') }}</p>
						<p>{{ item.source_amount }}</p>
					</div>
					<div class="item">
						<p>{{ $t('rtr_activity-c2c.purchase_price') }}</p>
						<p>
							1 <span class="fs_12">{{ item.source_asset_code }} = </span>
						</p>
						<p>
							{{ item.price }}
							<span class="fs_12">{{ item.target_asset_code }}</span>
						</p>
					</div>
					<div class="item">
						<p>{{ $t('rtr_activity-c2c.payment_asset') }}</p>
						<div class="asset_box">
							<span :class="[item.target_asset_code, 'small']"></span>
							<p class="code mr_4">{{ item.target_asset_code }}</p>
							<p class="name">{{ item.target_asset_title }}</p>
						</div>
					</div>
				</div>
				<div class="item status_area">
					<div :class="'status ' + item.status">
						<span class="icon"></span>
						<span>{{ $t('c2c.' + item.status) }}</span>
					</div>
				</div>
			</div>
			<!-- 테이블 컨텐츠2 -->
			<div class="list_item2">
				<div class="d_flex w40">
					<div class="item">
						<p>{{ $t('rtr_activity-c2c.total_fee') }}</p>
						<p>{{ item.fee_amount }}</p>
					</div>
					<div class="item">
						<p>{{ $t('rtr_activity-c2c.account_number') }}</p>
						<p>{{ item.deal_account_number }}</p>
					</div>
				</div>
				<div class="btn_area">
					<button class="button_bg_black" @click="$emit('showDetail', item)">
						{{ $t('button.detail') }}
					</button>
					<template
						v-if="
							item.escrow_type === 'DEALER' || item.escrow_type === 'DISABLE'
						"
					>
						<button
							v-if="item.status === 'PENDING'"
							class="button_bg_red"
							@click="privateApplicationHandler(item.seq, 'SET_PAYED')"
						>
							{{ $t('button.payment') }}
						</button>
						<button
							class="black"
							v-if="item.status === 'PENDING' || item.status === 'PAYED'"
							@click="privateApplicationHandler(item.seq, 'SET_CANCELED')"
						>
							{{ $t('button.cancel') }}
						</button>
					</template>
					<template v-if="item.escrow_type === 'APPLICANT'">
						<button
							v-if="item.status === 'PENDING' || item.status === 'PAYED'"
							class="blue2"
							@click="privateApplicationHandler(item.seq, 'SET_CONFIRMED')"
						>
							{{ $t('button.decide') }}
						</button>
						<button
							v-if="item.status === 'PENDING'"
							@click="privateApplicationHandler(item.seq, 'SET_CANCELED')"
						>
							{{ $t('button.cancel') }}
						</button>
					</template>
				</div>
			</div>
		</div>
		<pagination
			:totalCount="pageNavigation.total_count"
			:totalPage="pageNavigation.total_page"
			:curPage="pageNavigation.cur_page"
			:point="pageNavigation.point"
			:firstPage="pageNavigation.first_page"
			:lastPage="pageNavigation.last_page"
			@change="pageChangeHandler"
		></pagination>
	</div>
	<div v-else>
		<div class="list_none" v-if="!loading">
			<span class="ERRORGRAY"></span>
			<p>{{ $t('rtr_activity-c2c.empty') }}</p>
		</div>
	</div>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'success'" class="button_area">
			<button class="oneBtn" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'information'" class="button_area">
			<button @click="messageModal = false">
				{{ $t('button.cancel') }}
			</button>
			<button class="fc_red" @click="confirmHandler">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</ModalMessage>
</template>
<script>
import Pagination from '@/components/Pagination';
import ModalMessage from '@/components/Layout/ModalMessage';
import {
	cancelPrivateApplication,
	confirmPrivateApplication,
	fetchPrivateApplications,
	payPrivateApplication,
} from '@/api/application';
import { commonError } from '@/common/dialog';
export default {
	name: 'Purchase',
	emits: ['showDetail'],
	props: ['startDate', 'endDate'],
	components: {
		Pagination,
		ModalMessage,
	},
	data() {
		return {
			purchaseList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			messageModalMode: '',
			patchSeq: null,
			patchType: '',
			loading: false,
		};
	},
	watch: {
		startDate() {
			this.loadPurchaseList();
		},
		endDate() {
			this.loadPurchaseList();
		},
	},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			this.loadPurchaseList();
		},
		async loadPurchaseList() {
			this.loading = true;
			const params = {
				regdate_start: this.$dayjs(new Date(this.startDate))
					.startOf('day')
					.valueOf(),
				regdate_end: this.$dayjs(this.endDate).endOf('day').valueOf(),
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchPrivateApplications(
				params,
			).catch(commonError);
			this.loading = false;
			this.purchaseList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadPurchaseList();
		},
		privateApplicationHandler(seq, type) {
			this.patchSeq = seq;
			this.patchType = type;
			let message = '';
			switch (type) {
				case 'SET_CANCELED':
					message = this.$t('modal.message.set_cancel');
					break;
				case 'SET_PAYED':
					message = this.$t('modal.message.set_pay');
					break;
				case 'SET_CONFIRMED':
					message = this.$t('modal.message.set_confirm');
					break;
			}
			this.modalIcon = 'information';
			this.modalStatusMessage = message;
			this.messageModalMode = 'information';
			this.messageModal = true;
		},
		confirmHandler() {
			this.messageModal = false;
			switch (this.patchType) {
				case 'SET_CANCELED':
					this.cancelPrivateApplication();
					break;
				case 'SET_PAYED':
					this.payPrivateApplication();
					break;
				case 'SET_CONFIRMED':
					this.confirmPrivateApplication();
					break;
			}
		},
		async confirmPrivateApplication() {
			await confirmPrivateApplication(this.patchSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_confirm');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadPurchaseList();
				})
				.catch(commonError);
		},
		async cancelPrivateApplication() {
			await cancelPrivateApplication(this.patchSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_cancel');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadPurchaseList();
				})
				.catch(commonError);
		},
		async payPrivateApplication() {
			await payPrivateApplication(this.patchSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_payment');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadPurchaseList();
				})
				.catch(commonError);
		},
	},
};
</script>
<style scoped></style>
